import React from "react";
import { ExplainerSection, NAVY, CYAN, LIME, INK, LIGHT, RED } from "./ExplainerSection";

const FirewallIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Firewall filtert Datenverkehr">
    <rect width="400" height="260" fill={INK} />
    {/* Brick wall */}
    {[0, 1, 2, 3, 4, 5].map((row) => (
      <g key={row}>
        {[0, 1].map((col) => (
          <rect key={col} x={178 + (row % 2 === 0 ? 0 : 12) + col * 24} y={30 + row * 32} width={22} height={28} fill={NAVY} stroke={CYAN} strokeWidth="1" />
        ))}
      </g>
    ))}
    {/* Gate opening */}
    <rect x={186} y={110} width={28} height={40} fill={LIME} opacity="0.9" />
    {/* Good traffic passing */}
    <g>
      <circle cx="60" cy="130" r="6" fill={LIME}>
        <animate attributeName="cx" values="40;340" dur="2.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="60" cy="130" r="6" fill={CYAN}>
        <animate attributeName="cx" values="40;340" dur="2.5s" begin="1.2s" repeatCount="indefinite" />
      </circle>
    </g>
    {/* Bad traffic blocked */}
    <circle cx="60" cy="70" r="6" fill={RED}>
      <animate attributeName="cx" values="40;172;172" dur="2.5s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="1;1;0" dur="2.5s" repeatCount="indefinite" />
    </circle>
    <circle cx="60" cy="200" r="6" fill={RED}>
      <animate attributeName="cx" values="40;172;172" dur="2.5s" begin="0.8s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="1;1;0" dur="2.5s" begin="0.8s" repeatCount="indefinite" />
    </circle>
    <text x="90" y="52" fontFamily="ui-monospace, monospace" fontSize="9" fill={RED}>MALWARE ✕</text>
    <text x="280" y="120" fontFamily="ui-monospace, monospace" fontSize="9" fill={LIME}>ERLAUBT ✓</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      UTM-FIREWALL · NUR ERLAUBTES KOMMT DURCH
    </text>
  </svg>
);

const MailIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Mail-Security filtert Spam und Phishing">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Funnel */}
    <path d="M 120 40 L 280 40 L 220 130 L 220 180 L 180 180 L 180 130 Z" fill="none" stroke={NAVY} strokeWidth="3" />
    {/* Envelopes falling in */}
    {[{ x: 145, fill: NAVY, d: "0s" }, { x: 195, fill: RED, d: "0.7s" }, { x: 245, fill: NAVY, d: "1.4s" }].map((e, i) => (
      <g key={i}>
        <rect x={e.x} y="10" width="24" height="16" fill={e.fill} rx="2">
          <animate attributeName="y" values="0;30" dur="2s" begin={e.d} repeatCount="indefinite" />
          <animate attributeName="opacity" values="0;1;0" dur="2s" begin={e.d} repeatCount="indefinite" />
        </rect>
      </g>
    ))}
    {/* Clean mail out */}
    <rect x="188" y="195" width="24" height="16" fill={LIME} rx="2">
      <animate attributeName="y" values="185;215" dur="2s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite" />
    </rect>
    <path d="M 188 195 l 12 8 l 12 -8" fill="none" stroke={LIGHT} strokeWidth="1.5">
      <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite" />
    </path>
    {/* Quarantine box */}
    <rect x="300" y="90" width="70" height="50" fill="#fff" stroke={RED} strokeWidth="2" strokeDasharray="5 3" />
    <text x="335" y="112" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="8" fill={RED} fontWeight="bold">QUARANTÄNE</text>
    <text x="335" y="128" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="12" fill={RED}>✕ SPAM</text>
    <path d="M 250 70 Q 300 70 310 90" fill="none" stroke={RED} strokeWidth="1.5" strokeDasharray="4 3" />
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      MEHRSTUFIGER MAIL-FILTER · 24/7
    </text>
  </svg>
);

const AwarenessIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="Mitarbeiter werden zur Human Firewall">
    <rect width="400" height="260" fill={LIGHT} />
    {/* Phishing hook */}
    <line x1="120" y1="0" x2="120" y2="70" stroke={RED} strokeWidth="2">
      <animate attributeName="y2" values="40;80;40" dur="3s" repeatCount="indefinite" />
    </line>
    <path d="M 120 70 q 0 14 -12 12" fill="none" stroke={RED} strokeWidth="2">
      <animate attributeName="transform" values="translate(0,-30);translate(0,10);translate(0,-30)" dur="3s" repeatCount="indefinite" />
    </path>
    <text x="140" y="45" fontFamily="ui-monospace, monospace" fontSize="9" fill={RED}>PHISHING-VERSUCH</text>
    {/* People row */}
    {[0, 1, 2, 3].map((i) => {
      const x = 80 + i * 70;
      const trained = i !== 1;
      return (
        <g key={i}>
          <circle cx={x} cy={150} r={16} fill={trained ? NAVY : "#C6D2DB"} />
          <path d={`M ${x - 24} 205 q 0 -32 24 -32 q 24 0 24 32`} fill={trained ? NAVY : "#C6D2DB"} />
          {trained && (
            <g>
              <circle cx={x + 18} cy={132} r={9} fill={LIME} />
              <text x={x + 18} y={136} textAnchor="middle" fontSize="10" fontWeight="bold" fill={INK}>✓</text>
            </g>
          )}
        </g>
      );
    })}
    {/* Shield over the group */}
    <path d="M 330 60 l 26 9 v 26 q 0 20 -26 32 q -26 -12 -26 -32 v -26 z" fill="none" stroke={LIME} strokeWidth="3">
      <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite" />
    </path>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill={INK} letterSpacing="2">
      AWARENESS-TRAINING · HUMAN FIREWALL
    </text>
  </svg>
);

const SocIllu = () => (
  <svg viewBox="0 0 400 260" className="w-full h-auto" role="img" aria-label="24/7 Security Operations Center">
    <rect width="400" height="260" fill={INK} />
    {/* Pulsing rings */}
    <circle cx="200" cy="120" r="60" fill="none" stroke={CYAN} strokeWidth="1.5">
      <animate attributeName="r" values="50;95" dur="2.5s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.8;0" dur="2.5s" repeatCount="indefinite" />
    </circle>
    <circle cx="200" cy="120" r="60" fill="none" stroke={LIME} strokeWidth="1.5">
      <animate attributeName="r" values="50;95" dur="2.5s" begin="1.2s" repeatCount="indefinite" />
      <animate attributeName="opacity" values="0.8;0" dur="2.5s" begin="1.2s" repeatCount="indefinite" />
    </circle>
    {/* Eye in shield */}
    <path d="M 200 60 l 44 15 v 40 q 0 32 -44 50 q -44 -18 -44 -50 v -40 z" fill={NAVY} stroke={LIME} strokeWidth="2" />
    <ellipse cx="200" cy="120" rx="26" ry="15" fill="none" stroke="#fff" strokeWidth="2.5" />
    <circle cx="200" cy="120" r="7" fill={LIME}>
      <animate attributeName="r" values="6;8;6" dur="1.5s" repeatCount="indefinite" />
    </circle>
    {/* 24/7 badges */}
    <text x="70" y="80" fontFamily="ui-monospace, monospace" fontSize="16" fill={LIME} fontWeight="900">24/7</text>
    <text x="300" y="80" fontFamily="ui-monospace, monospace" fontSize="10" fill={CYAN}>BOCHUM · WIEN</text>
    <text x="70" y="200" fontFamily="ui-monospace, monospace" fontSize="9" fill="#fff" opacity="0.7">AUCH NACHTS</text>
    <text x="285" y="200" fontFamily="ui-monospace, monospace" fontSize="9" fill="#fff" opacity="0.7">AM WOCHENENDE</text>
    <text x="200" y="245" textAnchor="middle" fontFamily="ui-monospace, monospace" fontSize="10" fill="#fff" letterSpacing="2">
      SOC-ANALYSTEN WACHEN · IMMER
    </text>
  </svg>
);

const ITEMS = [
  { step: "01", illu: FirewallIllu, title: "Die Firewall ist Ihr Türsteher", desc: "Die Securepoint UTM prüft jedes Datenpaket, das rein oder raus will. Erlaubtes kommt durch, Malware und Angriffe prallen ab – rund um die Uhr, von uns gemanagt.", testId: "firewall" },
  { step: "02", illu: MailIllu, title: "E-Mails werden vorsortiert", desc: "Über 90 % aller Angriffe starten per E-Mail. Unsere mehrstufige Mail-Security filtert Spam und Phishing heraus, bevor sie ein Postfach erreichen – Verdächtiges landet in Quarantäne.", testId: "mail" },
  { step: "03", illu: AwarenessIllu, title: "Ihre Mitarbeiter werden zur Firewall", desc: "Technik allein reicht nicht. Mit regelmäßigen Trainings und Phishing-Simulationen lernen Ihre Mitarbeitenden, Betrugsversuche selbst zu erkennen – messbar und nachweisbar.", testId: "awareness" },
  { step: "04", illu: SocIllu, title: "Ein Team wacht – auch nachts", desc: "Angriffe passieren um 3 Uhr morgens und an Feiertagen. Unsere SOC-Analysten in Bochum und Wien überwachen Ihre IT 24/7 und greifen sofort ein, wenn etwas auffällt.", testId: "soc" },
];

export const SecurityExplainers = () => (
  <ExplainerSection
    eyebrow="So funktioniert Managed Security"
    titleA="Vier Schutzschichten."
    titleB="Einfach erklärt."
    intro="IT-Sicherheit muss nicht kompliziert klingen. Hier sehen Sie visuell, wie unsere Bausteine Ihr Unternehmen schützen – ohne Fach-Chinesisch."
    items={ITEMS}
    testId="security-explainers"
  />
);
